import React from "react";

// Assume props are passed correctly as per the previous working state
export default function RenderFields({
  fields,
  formData,
  handleChange,
  readOnly = false,
  validationErrors = {},
  maintenanceOptions = [],
  performingOptions = [],
  witnessOptions = [],
}) {
  return (
    <>
      {fields.map((field) => {
        const isFieldReadOnly = readOnly || field.readOnly;
        const isDisplayOnly = field.displayOnly;

        const fieldValue = formData[field.name] || "";

        // --- Determine Input Type ---
        const inputType = field.type === "date" ? "datetime-local" : "text";

        // --- Prepare Value for Editable Input ---
        let valueForInput = fieldValue;
        if (field.type === "date" && fieldValue) {
          try {
            const dateObj = new Date(fieldValue);
            valueForInput = dateObj.toISOString().slice(0, 16);
          } catch (e) {
            console.error(
              `Invalid date value for input ${field.name}:`,
              fieldValue
            );
            valueForInput = "";
          }
        }

        // --- Determine Value/Name for Display (Read-Only/Labels) ---
        let displayedValueOrName = fieldValue;
        if (field.type === "date" && fieldValue) {
          try {
            displayedValueOrName = new Date(fieldValue).toLocaleString();
          } catch (e) {
            displayedValueOrName = fieldValue;
          }
        }

        const isServiceCoSelect = field.type === "serviceCompanySelect";
        const isFixedSelect = field.type === "select" && field.options;

        let companiesToUse = [];
        if (isServiceCoSelect) {
          if (field.name === "maintenanceCoId") {
            companiesToUse = maintenanceOptions;
          } else if (field.name === "performingCoId") {
            companiesToUse = performingOptions;
          } else if (field.name === "witnessCoId") {
            companiesToUse = witnessOptions;
          }

          if (fieldValue) {
            const found = companiesToUse.find(
              (co) => co.serviceCompanyId === Number(fieldValue)
            );
            displayedValueOrName = found
              ? found.companyName
              : `(ID: ${fieldValue} Not Found)`;
          } else {
            displayedValueOrName = "N/A";
          }
        }

        if (isFixedSelect && fieldValue && field.options) {
          const foundOpt = field.options.find(
            (opt) => String(opt.value) === String(fieldValue)
          );
          displayedValueOrName = foundOpt ? foundOpt.label : fieldValue;
        }

        return (
          <div key={field.name} className="flex items-center w-full mb-4">
            {/* LABEL */}
            <div
              style={{ width: "200px", paddingRight: "10px", flexShrink: 0 }}
            >
              <label className="font-semibold break-words">{field.label}</label>
            </div>

            {/* Dotted separator */}
            <div style={{ width: "100px", margin: "0 10px", flexShrink: 0 }}>
              <span className="block border-dotted border-b-4 border-gray-200 w-full"></span>
            </div>

            {/* INPUT / DISPLAY CONTAINER */}
            {/* Keep minWidth: 0 */}
            <div style={{ flexGrow: 1, minWidth: 0 }}>
              {isDisplayOnly || isFieldReadOnly ? (
                <div
                  className={`truncate box-border p-2 border border-gray-300 rounded-md bg-gray-100 w-full min-h-[40px] ${
                    validationErrors[field.name] ? "border-red-500" : ""
                  }`}
                >
                  {displayedValueOrName || "N/A"}
                </div>
              ) : isServiceCoSelect ? (
                <select
                  name={field.name}
                  className={`truncate box-border border ${
                    validationErrors[field.name]
                      ? "border-red-500"
                      : "border-gray-300"
                  } p-2 rounded-md w-full`}
                  value={fieldValue}
                  onChange={handleChange}
                  aria-label={`Select ${field.label}`}
                >
                  <option value="">-- Select Service Company --</option>
                  {companiesToUse.map((co) => (
                    <option
                      key={co.serviceCompanyId}
                      value={co.serviceCompanyId}
                    >
                      {co.companyName}
                    </option>
                  ))}
                </select>
              ) : isFixedSelect ? (
                <select
                  name={field.name}
                  className={`truncate box-border border ${
                    validationErrors[field.name]
                      ? "border-red-500"
                      : "border-gray-300"
                  } p-2 rounded-md w-full`}
                  value={fieldValue}
                  onChange={handleChange}
                  aria-label={field.label}
                >
                  {field.options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type={inputType}
                  name={field.name}
                  className={`truncate box-border border ${
                    validationErrors[field.name]
                      ? "border-red-500"
                      : "border-gray-300"
                  } p-2 rounded-md w-full`}
                  value={valueForInput}
                  onChange={handleChange}
                  aria-label={field.label}
                />
              )}
              {/* Validation Errors */}
              {validationErrors[field.name] && (
                <p className="text-red-500 text-sm mt-1">
                  {validationErrors[field.name]}
                </p>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
}
